import Image from "next/legacy/image";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ContentSection from "sections/landingPage/ContentSection";

import styles from "./styles";

const InfoMission = () => {
  return (
    <Box position="relative">
      <ContentSection gridContainerProps={{ spacing: 6, alignItems: "start" }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography component="h2" variant="h1" align="center">
            Mission
          </Typography>
          <Box sx={styles.image}>
            <Image
              src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/aboutPage/mission.png`}
              alt=""
              width={210}
              height={341}
            />
          </Box>
          <Typography paragraph align="center">
            Uniqly team's mission is to build web3 first e-commerce platform
            where next-generation shopping experiences are taking place. We are
            enabling creators, artists, and brands to sell their fashion and
            lifestyle products through NFTs and unique storytelling ultimately
            redefining the e-commerce customer journey.
            <br />
            <br />
            As a team we stand for NFT as technology that will transform and
            extend capabilities of many industries, changing the way we interact
            with products and our behaviors in digital space.
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography component="h2" variant="h1" align="center">
            Vision
          </Typography>
          <Box sx={styles.image}>
            <Image
              src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/aboutPage/vision.png`}
              alt=""
              width={192}
              height={341}
            />
          </Box>
          <Typography paragraph align="center">
            We believe that every asset will have its digital counterpart with
            the NFT technology behind it. We put confidence in the world in
            which every existing item has an additional layer of decentralised
            and secured information, providing users data, metrics, and history
            of the assets, augmenting the possible capabilities both in the real
            world and metaverses.
          </Typography>
        </Box>
      </ContentSection>
    </Box>
  );
};

export default InfoMission;
